import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import useAppStore from "@/store/appStore";

type ConfirmationDialogProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
};

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  description,
}: ConfirmationDialogProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { direction } = useAppStore();

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    if (!newOpen) {
      onCancel();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    handleOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className={`sm:max-w-md ${direction === 'rtl' ? "[&>button]:left-4 [&>button]:right-auto" : ""}`}
        dir={direction}
      >
        <DialogHeader>
          <DialogTitle className={direction === "rtl" ? "text-right" : ""}>
            {title ?? t("confirmationDialog.title")}
          </DialogTitle>
          <DialogDescription className={direction === "rtl" ? "text-right" : ""}>
            {description ?? t("confirmationDialog.desc")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => handleOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button variant="default" onClick={handleConfirm}>
            {t("common.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
